import { add } from "date-fns";
import Logging from "../Logging.js";
import userStore from "../stores/userStore.js";
function isValueWithExpiration(value) {
  return typeof value === "object" && value !== null && "expirationDate" in value;
}
const _LocalStorageUtil = class _LocalStorageUtil {
  static get(info, defaultValue) {
    let serializedValue = null;
    try {
      const key = this.getKey(info);
      if (key) {
        serializedValue = window.localStorage.getItem(key);
      }
    } catch (error) {
      void Logging.warning(error);
    }
    if (serializedValue) {
      let value = JSON.parse(serializedValue);
      if (isValueWithExpiration(value)) {
        if (value.expirationDate > (/* @__PURE__ */ new Date()).getTime()) {
          value = value.value;
        } else {
          value = defaultValue;
        }
      }
      return this.parseDates(value);
    }
    return defaultValue;
  }
  static remove(info) {
    try {
      const key = this.getKey(info);
      if (key) {
        window.localStorage.removeItem(key);
      }
    } catch (error) {
      void Logging.warning(error);
    }
  }
  static set(info, value) {
    let valueToSerialize = value;
    if (info.ttl) {
      valueToSerialize = {
        // eslint-disable-next-line no-restricted-syntax
        expirationDate: add(/* @__PURE__ */ new Date(), info.ttl).getTime(),
        value
      };
    }
    const serializedValue = JSON.stringify(valueToSerialize);
    try {
      const key = this.getKey(info);
      if (key) {
        window.localStorage.setItem(key, serializedValue);
      }
    } catch (error) {
      void Logging.warning(error);
    }
  }
  static getKey(info) {
    let storageName = this.keyPrefix;
    if (window.isTesting) {
      return null;
    }
    if (!info.userIndependant) {
      const uniqueUserId = userStore.get().uniqueUserId;
      if (uniqueUserId) {
        storageName += `_${uniqueUserId}`;
      } else {
        void Logging.warning(
          new Error("No unique user id found, cache is disabled")
        );
        storageName = null;
      }
    }
    if (!info.pathIndependant && storageName !== null) {
      storageName += `_${window.location.pathname.replace(/\/\d+/g, "")}`;
    }
    return storageName ? `${storageName}_${info.key}` : null;
  }
  static parseDates(data) {
    if (data === void 0 || data === null) {
      return data;
    }
    if (Array.isArray(data)) {
      for (let i = 0; i < data.length; i++) {
        data[i] = this.parseDates(data[i]);
      }
      return data;
    }
    const recordData = data;
    switch (typeof data) {
      case "object":
        for (const childPropName of Object.keys(data)) {
          recordData[childPropName] = this.parseDates(
            recordData[childPropName]
          );
        }
        break;
      case "string":
        if (/^\d\d\d\d-\d\d-\d\d/.test(data)) {
          const date = new Date(data);
          if (!isNaN(date.getTime())) {
            return date;
          }
        }
        break;
    }
    return data;
  }
};
_LocalStorageUtil.keyPrefix = "";
let LocalStorageUtil = _LocalStorageUtil;
export {
  LocalStorageUtil as default
};
//# sourceMappingURL=LocalStorageUtil.js.map
